import { render, staticRenderFns } from "./system-simulation-checkout-payment.vue?vue&type=template&id=1296e7ce&scoped=true"
import script from "./system-simulation-checkout-payment.vue?vue&type=script&lang=js"
export * from "./system-simulation-checkout-payment.vue?vue&type=script&lang=js"
import style0 from "./system-simulation-checkout-payment.vue?vue&type=style&index=0&id=1296e7ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296e7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1296e7ce')) {
      api.createRecord('1296e7ce', component.options)
    } else {
      api.reload('1296e7ce', component.options)
    }
    module.hot.accept("./system-simulation-checkout-payment.vue?vue&type=template&id=1296e7ce&scoped=true", function () {
      api.rerender('1296e7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/system-simulation-checkout-payment.vue"
export default component.exports